import React, { useState } from "react";
import { useApp } from "../../context/AppContext";
import { FONT_SIZES, FONT_FAMILY } from "../../constants/appConfig";

export const FormInput = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  required,
  disabled,
}) => {
  const { palette } = useApp();
  const [isFocused, setIsFocused] = useState(false);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {label && (
        <label
          style={{
            fontSize: FONT_SIZES.sm,
            fontWeight: 600,
            color: palette.text2,
            fontFamily: FONT_FAMILY,
          }}
        >
          {label}
          {required && <span style={{ color: "#ef4444" }}> *</span>}
        </label>
      )}
      <input
        type={type}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        style={{
          padding: "8px 12px",
          borderRadius: 8,
          fontSize: FONT_SIZES.md,
          fontFamily: FONT_FAMILY,
          outline: "none",
          background: palette.inputBg,
          color: palette.inputColor,
          border: `1px solid ${
            isFocused ? palette.focusBorder : palette.inputBorder
          }`,
          boxShadow: isFocused ? palette.focusShadow : "none",
          opacity: disabled ? 0.6 : 1,
          transition: "all 0.2s",
        }}
      />
    </div>
  );
};

export const FormSelect = ({
  label,
  value,
  onChange,
  options,
  placeholder,
  disabled = false,
  style: extraStyle = {},
}) => {
  const { palette } = useApp();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
        ...extraStyle,
      }}
    >
      {label && (
        <label
          style={{
            fontSize: FONT_SIZES.sm,
            fontWeight: 600,
            color: palette.text2,
            fontFamily: FONT_FAMILY,
          }}
        >
          {label}
        </label>
      )}
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        style={{
          padding: "8px 12px",
          borderRadius: 8,
          fontSize: FONT_SIZES.md,
          fontFamily: FONT_FAMILY,
          outline: "none",
          cursor: disabled ? "default" : "pointer",
          background: palette.inputBg,
          color: palette.inputColor,
          border: `1px solid ${palette.inputBorder}`,
          transition: "all 0.2s",
          appearance: "auto",
          opacity: disabled ? 0.6 : 1,
        }}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option
            key={option.value !== undefined ? option.value : option}
            value={option.value !== undefined ? option.value : option}
          >
            {option.label || option}
          </option>
        ))}
      </select>
    </div>
  );
};
